import { Grid, makeStyles, Typography, Box } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(
  ({ spacing, breakpoints, palette, typography }) => ({
    root: {
      [breakpoints.up('md')]: {
        marginLeft: spacing(8),
        marginRight: spacing(8),
      },
    },
    title: {
      color: palette.primary.main,
      ...typography.h5,
      [breakpoints.up('md')]: {
        ...typography.h4,
      },
    },
  })
);

export const ShortDescription = () => {
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} md={5}>
        <Typography className={classes.title} component="h3">
          Why HabFit is Awesome
        </Typography>
        <Box mt={2} />
        <Typography
          variant="subtitle1"
          style={{ maxWidth: '610px' }}
          component="h4"
        >
          Having a fitness coach sometimes could be pricey. HabFit resolves this
          issue by providing the new training format that will benefit both
          customers and coaches.
          <br />
          <br />
          With this format, we can decrease the average price for personal training by <b>80%</b> without affecting the workout quality!
        </Typography>
      </Grid>
      <Grid item xs={12} md={7}>
        <Box mt={4} mx={{ xs: 2, md: 10 }}>
          <img
            width="311px"
            height="201.75px"
            src="saving_money.svg"
            alt="saving money"
          />
        </Box>
      </Grid>
    </Grid>
  );
};
